import { Progress } from "@/components/ui/progress";
import { Users, UserCheck, Clock } from "lucide-react";

interface SeatUsageIndicatorProps {
  usedSeats: number;
  maxSeats: number;
  activeMembers?: number;
  pendingInvites?: number;
}

export function SeatUsageIndicator({ usedSeats, maxSeats, activeMembers, pendingInvites }: SeatUsageIndicatorProps) {
  const percentage = Math.min((usedSeats / maxSeats) * 100, 100);
  const isNearLimit = percentage >= 80;

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Users className="w-4 h-4 text-muted-foreground" aria-hidden="true" />
          <span className="text-sm font-medium text-foreground" id="seat-usage-label">Sitz-Auslastung</span>
        </div>
        <div className="text-right">
          <span className={`text-lg font-semibold ${isNearLimit ? 'text-destructive' : 'text-foreground'}`}>
            {usedSeats}
          </span>
          <span className="text-muted-foreground text-sm"> / {maxSeats}</span>
        </div>
      </div>
      
      <Progress 
        value={percentage} 
        className={`h-2 ${isNearLimit ? '[&>div]:bg-destructive' : ''}`}
        aria-label={`Sitzplatzauslastung: ${usedSeats} von ${maxSeats} Plätzen belegt`}
        aria-labelledby="seat-usage-label"
      />
      
      <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
        {activeMembers !== undefined && (
          <div className="flex items-center gap-1.5">
            <UserCheck className="w-3.5 h-3.5 text-green-600 dark:text-green-400" aria-hidden="true" />
            <span>{activeMembers} aktiv</span>
          </div>
        )}
        {pendingInvites !== undefined && pendingInvites > 0 && (
          <div className="flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5 text-amber-600 dark:text-amber-400" aria-hidden="true" />
            <span>{pendingInvites} ausstehend</span>
          </div>
        )}
        <div className="ml-auto">
          {maxSeats - usedSeats} verfügbar
        </div>
      </div>
    </div>
  );
}
